var map = {
	"./logo_section_datenauswertung.jpg": 1295,
	"./logo_section_dateneingabe.jpg": 2478,
	"./logo_section_informationen_hilfe.jpg": 2479,
	"./logo_section_zusatztools.jpg": 2480
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 433;